"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var event_1 = require("../../util/event");
exports.EVENT_MAP = event_1.EVENT_MAP;
exports.onEvent = event_1.onEvent;
var SHAPE_EVENT_MAP = {
    onColumnClick: 'interval:click',
    onColumnDblclick: 'interval:dblclick',
    onColumnMousemove: 'interval:mousemove',
    onColumnMouseenter: 'interval:mouseenter',
    onColumnMouseleave: 'interval:mouseleave',
    onColumnMousedown: 'interval:mousedown',
    onColumnMouseup: 'interval:mouseup',
    onColumnContextmenu: 'interval:contextmenu',
};
_.assign(event_1.EVENT_MAP, SHAPE_EVENT_MAP);
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/column/event.js
// module id = 348
// module chunks = 37